<template>
    <div class="sa-tab-scroll">
        <b-card class="sa-card" header="Data Evento" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">{{ this.getLabelTraduora("patient.cardiology.lblEventDate") }}</label>
                    <label class="sa-label-data">{{ formatDateTime(jsonData.dataEvento) }}</label>
                </b-col>
            </b-row>
        </b-card>
        <b-card class="sa-card" header="ANAMNESI" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Fonte Dati</label>
                    <label class="sa-label-data">{{ jsonData.fonteDati }}</label>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="8" lg="8" xl="8">
                    <label class="sa-label-data">Altro</label>
                    <label class="sa-label-data">{{ jsonData.fonteDatiAltro }}</label>
                </b-col>
            </b-row>
        </b-card>
        <b-card class="sa-card" header="ANAMNESI FISIOLOGICA" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Allergie</label>
                    <label class="sa-label-data">{{ jsonData.allergie }}</label>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="8" lg="8" xl="8">
                    <label class="sa-label-data">Altro</label>
                    <label class="sa-label-data">{{ jsonData.allergieAltro }}</label>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">Fumo</label>
                    <label class="sa-label-data">{{ jsonData.fumo }}</label>
                </b-col>
            </b-row>
        </b-card>
        <b-card class="sa-card" header="ANAMNESI PATOLOGICA" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Malattie Autoimmuni</label>
                    <label class="sa-label-data">{{ jsonData.malattieAutoimmuni }}</label>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="8" lg="8" xl="8">
                    <label class="sa-label-data">Note</label>
                    <label class="sa-label-data">{{ jsonData.malattieAutoimmuniNote }}</label>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Assunzione Farmaci</label>
                    <label class="sa-label-data">{{ jsonData.assunzioneFarmaci }}</label>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="8" lg="8" xl="8">
                    <label class="sa-label-data">Note</label>
                    <label class="sa-label-data">{{ jsonData.assunzioneFarmaciNote }}</label>
                </b-col>
            </b-row>
        </b-card>
        <b-card class="sa-card" header="INTERVENTI CHIRURGICI" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Interventi Chirurgici</label>
                    <label class="sa-label-data">{{ jsonData.interventiChirurgici }}</label>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="8" lg="8" xl="8">
                    <label class="sa-label-data">Note</label>
                    <label class="sa-label-data">{{ jsonData.interventiChirurgiciNote }}</label>
                </b-col>
            </b-row>
        </b-card>
        <b-card class="sa-card" header="PRECEDENTI TRATTAMENTI DI MEDICINA ESTETICA" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Precedenti Trattamenti</label>
                    <label class="sa-label-data">{{ jsonData.precedentiTrattamentiMedicinaEstetica }}</label>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="8" lg="8" xl="8">
                    <label class="sa-label-data">Note</label>
                    <label class="sa-label-data">{{ jsonData.precedentiTrattamentiMedicinaEsteticaNote }}</label>
                </b-col>
            </b-row>
        </b-card>
        <b-card class="sa-card" header="MOTIVO DELLA VISITA" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">{{ jsonData.motivoVisita }}</label>
                </b-col>
            </b-row>
        </b-card>
        <b-card class="sa-card" header="ESAME OBIETTIVO LOCALE" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">{{ jsonData.esameObiettivoLocale }}</label>
                </b-col>
            </b-row>
        </b-card>
        <b-card class="sa-card" header="FARMACI" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">{{ jsonData.farmaci }}</label>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>
<script>
import axios from "axios";
import UtilityMixin from "../../../../../utility/UtilityMixin";
export default {
    components: {},
    mixins: [UtilityMixin],

    props: {
        utente: {
            type: Object,
            default: function () {
                return null;
            },
        },
        jsonData: {
            type: Object,
            default: function () {
                return {
                    conclusioni: "",
                    dataEvento: new Date().getTime(),
                };
            },
        },
    },
    mounted() {
        let me = this;
        me.id = this.$route.params.id;
        me.jsonData.dataEvento = new Date().getTime();
        me.loadData();
    },
    watch: {
        jsonData: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
        // currentPage() {
        //     let me = this;
        //     me.loadDatiPacs();
        // },
    },
    data() {
        return {
            rows: 0,
            currentPage: 1,
            perPage: 10,
            pathResource: "/anamnesibotox",
            isDisalble: false,
            linkPacs: "",
            id: "-1",
            idRisorsa: null,
        };
    },
    methods: {
        loadData() {
            let me = this;
            me.showModalLoading = true;
            if (me.id === "-1") {
                me.showModalLoading = false;
            } else {
                let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + me.id;
                axios.get(link).then((response) => {
                    this.$emit("update", response.data.data);
                    // me.loadDatiPacs();
                    me.showModalLoading = false;
                });
            }
        },

        onUpdateBase64() {},
        onUpdateLista(data) {
            let me = this;
            me.listaRichieste = data;
            if (me.listaRichieste.length > 0) {
                me.disableCampi = true;
                if (me.listaRichieste[0].statoAttuale !== "IN VISITA") {
                    me.disableCampi = false;
                }
            }
        },
        onVisualizza(id) {
            let me = this;
            me.isDisalble = false;
            let link = process.env.VUE_APP_PATH_API + me.pathPacsEndpoint + id;
            axios.get(link).then((response) => {
                me.linkPacs = "";
                me.linkPacs = response.data.data.url;
                console.log(me.linkPacs);
            });
        },
        onClose() {
            let me = this;
            me.linkPacs = "";
        },
    },
};
</script>

<style></style>
